var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackspace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.07 0.671273C10.4495 0.244296 10.9935 0 11.5648 0H30C31.1046 0 32 0.895431 32 2V22C32 23.1046 31.1046 24 30 24H11.5648C10.9935 24 10.4495 23.7557 10.07 23.3287L1.18109 13.3287C0.507517 12.571 0.507516 11.429 1.18109 10.6713L10.07 0.671273Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7573 7.75774C15.3668 8.14826 15.3668 8.78143 15.7573 9.17195L18.5857 12.0004L15.7572 14.8288C15.3667 15.2194 15.3667 15.8525 15.7572 16.243C16.1478 16.6336 16.7809 16.6336 17.1715 16.243L19.9999 13.4146L22.8284 16.243C23.2189 16.6335 23.8521 16.6335 24.2426 16.243C24.6331 15.8525 24.6331 15.2193 24.2426 14.8288L21.4141 12.0004L24.2425 9.17198C24.6331 8.78146 24.6331 8.14829 24.2425 7.75777C23.852 7.36724 23.2188 7.36724 22.8283 7.75777L19.9999 10.5862L17.1715 7.75774C16.781 7.36721 16.1478 7.36721 15.7573 7.75774Z",
    fill: "#7B7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackspace);
export default __webpack_public_path__ + "static/media/backspace.b463f6d49bea673a237b92d26375b401.svg";
export { ForwardRef as ReactComponent };